import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, BigButton } from "@/components/Field";
import { TextArea } from "@/components/Bits";
import { api, errMsg } from "@/lib/api";

const EMPTY = { nome: "", documento: "", inscricao_estadual: "", telefone: "", whatsapp: "", email: "", responsavel: "", data_nascimento: "", observacoes: "" };

export const ClienteFormDialog = ({ open, onOpenChange, editing, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setForm(editing ? Object.fromEntries(Object.keys(EMPTY).map((k) => [k, editing[k] || ""])) : EMPTY);
  }, [open, editing]);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = editing ? await api.put(`/clientes/${editing.cliente_id}`, form) : await api.post("/clientes", form);
      toast.success(editing ? "Cliente atualizado" : "Cliente cadastrado");
      onOpenChange(false);
      onSaved(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl rounded-3xl max-h-[92vh] overflow-y-auto" data-testid="cliente-form-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">{editing ? "Editar cliente" : "Novo cliente"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid sm:grid-cols-2 gap-4 mt-2">
          <div className="sm:col-span-2"><Field label="Nome / Razão Social *" id="c-nome" required value={form.nome} onChange={set("nome")} data-testid="cliente-form-nome" /></div>
          <Field label="CPF / CNPJ" id="c-doc" inputMode="numeric" value={form.documento} onChange={set("documento")} data-testid="cliente-form-documento" />
          <Field label="Inscrição estadual" id="c-ie" value={form.inscricao_estadual} onChange={set("inscricao_estadual")} data-testid="cliente-form-ie" />
          <Field label="Responsável" id="c-resp" value={form.responsavel} onChange={set("responsavel")} data-testid="cliente-form-responsavel" />
          <Field label="Telefone" id="c-tel" type="tel" value={form.telefone} onChange={set("telefone")} data-testid="cliente-form-telefone" />
          <Field label="WhatsApp" id="c-wpp" type="tel" value={form.whatsapp} onChange={set("whatsapp")} data-testid="cliente-form-whatsapp" />
          <Field label="Data de nascimento" id="c-nasc" type="date" value={form.data_nascimento} onChange={set("data_nascimento")} data-testid="cliente-form-nascimento" />
          <div className="sm:col-span-2"><Field label="E-mail" id="c-email" type="email" value={form.email} onChange={set("email")} data-testid="cliente-form-email" /></div>
          <div className="sm:col-span-2"><TextArea label="Observações" id="c-obs" value={form.observacoes} onChange={set("observacoes")} data-testid="cliente-form-observacoes" /></div>
          <p className="sm:col-span-2 text-xs text-[#5C6B66]">Se existir uma conta de acesso de cliente com o mesmo e-mail, ela será vinculada automaticamente.</p>
          <div className="sm:col-span-2">
            <BigButton type="submit" disabled={busy} data-testid="cliente-form-submit">{busy && <Loader2 className="h-5 w-5 animate-spin" />} Salvar</BigButton>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
